import { render, staticRenderFns } from "./viewFile.vue?vue&type=template&id=6e21df5d"
import script from "./viewFile.vue?vue&type=script&lang=js"
export * from "./viewFile.vue?vue&type=script&lang=js"
import style0 from "./viewFile.vue?vue&type=style&index=0&id=6e21df5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports